import { ALERT_MESSAGES } from '../../messages/message.constant';
import { REQUEST_MESSAGE_CONSTANTS } from '../../translate-messages/ngrx-store/request';
import { API_METHOD_CONSTANTS } from '../core';

export const REQUEST_METHOD_CONSTANT = {
  USER_REQUEST: 'USER_REQUEST',
  LEAVE_REQUEST: 'LEAVE_REQUEST',
  OPEN_REQUEST: 'OPEN_REQUEST',
  SWAP_REQUEST: 'SWAP_REQUEST'
};

export const REQUEST_NGRX_CONSTANTS = {


  [REQUEST_METHOD_CONSTANT.SWAP_REQUEST]: {
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getSwapRequestList',
      STATE: 'userRequestList',
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS_NOTIFICATION: false,
      INDIVIDUAL: false,
      CACHING: false,
    },
    [API_METHOD_CONSTANTS.EXPORT]: {
      API_METHOD: 'getSwapRequestAllList',
      STATE: 'common',
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: '',
      SUCCESS_NOTIFICATION: false,
    },
  },
  [REQUEST_METHOD_CONSTANT.OPEN_REQUEST]: {
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getOpenRequestList',
      STATE: 'userRequestList',
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS_NOTIFICATION: false,
      INDIVIDUAL: false,
      CACHING: false,
    },
    [API_METHOD_CONSTANTS.EXPORT]: {
      API_METHOD: 'getOpenRequestAllList',
      STATE: 'common',
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: '',
      SUCCESS_NOTIFICATION: false,
    },
  },

  [REQUEST_METHOD_CONSTANT.USER_REQUEST]: {
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getUserRequestList',
      STATE: 'userRequestList',
      API_RESPONSE: 'data.business',
      TITLE: REQUEST_MESSAGE_CONSTANTS.TITLE_USER_REQUEST,
      SUCCESS_NOTIFICATION: false,
      INDIVIDUAL: false,
      CACHING: false,
      UNIQUE_KEY: 'user_id',
    },
    [API_METHOD_CONSTANTS.APPROVE]: {
      API_METHOD: 'approveRejectUserRequest',
      STATE: 'common',
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: ALERT_MESSAGES.APPROVE_SUCCESS,
      SUCCESS_NOTIFICATION: true,
    },
    [API_METHOD_CONSTANTS.REJECT]: {
      API_METHOD: 'approveRejectUserRequest',
      STATE: 'common',
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: ALERT_MESSAGES.REJECT_SUCCESS,
      SUCCESS_NOTIFICATION: true,
    },
  },
  [REQUEST_METHOD_CONSTANT.LEAVE_REQUEST]: {
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getLeaveRequestList',
      STATE: 'getLeaveRequestList',
      API_RESPONSE: 'data',
      TITLE: REQUEST_MESSAGE_CONSTANTS.TITLE_USER_REQUEST,
      SUCCESS_NOTIFICATION: false,
      INDIVIDUAL: false,
      CACHING: false,
      UNIQUE_KEY: 'user_id',
    },
    [API_METHOD_CONSTANTS.APPROVE]: {
      API_METHOD: 'approveRejectLeaveRequest',
      STATE: 'common',
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: ALERT_MESSAGES.APPROVE_SUCCESS,
      SUCCESS_NOTIFICATION: true,
    },
    [API_METHOD_CONSTANTS.REJECT]: {
      API_METHOD: 'approveRejectLeaveRequest',
      STATE: 'common',
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: ALERT_MESSAGES.REJECT_SUCCESS,
      SUCCESS_NOTIFICATION: true,
    },
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getLeaveById',
      STATE: 'common',
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: '',
      SUCCESS_NOTIFICATION: false,
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getLeaveRequestAll',
      STATE: 'common',
      API_RESPONSE: 'data',
      TITLE: '',
      SUCCESS: '',
      SUCCESS_NOTIFICATION: false,
    },
  },
};
